/**
 * StarterKit에서 비활성화하는 스키마 노드 옵션.
 * 이 노드들은 전용 확장(Link/List)이 대신 제공하므로 프론트/백엔드가 동일하게 끈다.
 * codeBlock도 CodeBlockLowlight 기반 전용 코드 블록(프론트: EnhancedCodeBlock,
 * 공유: BaseCodeBlock)이 해당 노드를 제공하므로 함께 끈다. 그렇지 않으면
 * StarterKit의 codeBlock과 중복 등록되어 tiptap 경고가 발생한다.
 * undoRedo는 협업 여부에 따라 프론트에서 개별 설정하므로 여기 포함하지 않는다(동작 옵션).
 */
export const SHARED_STARTERKIT_OPTIONS = {
  link: false,
  codeBlock: false,
  bulletList: false,
  orderedList: false,
  listItem: false,
} as const;
